// extracted by mini-css-extract-plugin
export var discountCodeBubbleContainer = "_li-0";
export var discountCodeInput = "_li-1";